export const HomeConstants = {
    COMPLETED_STATUS: 'completed',
};
export const DEFAULT_CLUSTER_NAME = 'TAKE';
